import React, { useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang';
import { VariableProjectType } from './VariableProjectType';
import { putProjectType } from '../../store/Actions/ActionProjectType';
import { Form } from '../general/general-component/abstruct-component/AbstructForm';
import '../../assets/styles/StylePopup.css'

function EditProjectType({ arr, open, setOpen }) {
    const { mode, dispatch, langLocal } = AbstructVar();
    const { translate } = AbstructLang();
    const { state, setStateCustom, setLoad, setState } = VariableProjectType();

    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            name: arr.name,
            type: arr.type
        }));
    }, [arr]);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(putProjectType(arr.id, state.name, state.type, setLoad));
    };
    const formFields = [
        { name: 'name', label: 'name', type: 'text', inputType: 'text', iconType: "pencil" },
        {
            name: "type", label: "Type", type: "text", inputType: 'one_select', iconType: "role",
            options: [{ value: 'short_series', label: 'Short Series' }, { value: 'series', label: 'Series' },
            { value: 'short_film', label: 'Short Film' }, { value: 'film', label: 'Film' },
            { value: 'documentary', label: 'Documentary' }
            ],
            defaultvaluee: { value: state.type, label: state.type }
        }
    ];

    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: 'popupR',
            }}
            focusTrapped={false}
            overlayOpacity={0.5}
        >
            <div className={`div_popup ${mode === 'dark' ? 'darkPopUp' : 'lightPopUp'}`}>
                <div className={`div_title_popup ${mode === 'dark' ? 'darktoppopup' : 'lighttoppopup'}`}>
                    <p className={`title_popup ${mode === 'dark' ? 'darktext' : 'lighttext'}`}>{translate('edit_project_type')}</p>
                </div>
                <Form langLocal={langLocal} fields={formFields} handleSubmit={handleSubmit} state={state} setStateCustom={setStateCustom} translate={translate} buttonLabel="edit" />
            </div>
        </RModal>
    );
}

export default EditProjectType;

